export const invite = {
  fuwutiaokuan: '《服务条款》',
  yinsizhengce: '《隐私政策》',
  fzcg: '复制成功',
  yqhy: "邀请好友",
  fxlj: "分享链接",
  register_now: '立即注册',
  phone: '手机',
  email: '邮箱',
  placehold_phone: '请输入您的手机号码',
  placehold_email: '请输入您的邮箱',
  placehold_code: '邀请码',
  argee: '我已阅读并同意',
  agreement: '《BiKing用户协议》',
  register: '注册',
  phone_code: '短信验证码',
  email_code: '邮箱验证码',
  code_to_phone: '验证码已经以短信的形式发送到您的手机上',
  code_to_email: '验证码已经以邮箱的形式发送到您的邮箱上',
  has_sent: '已发送验证码至：',
  resend: '重新发送',
  send_code: '发送验证码',
  unable_code: '无法收到验证码？',
  set_pwd: '设置密码',
  placehold_pwd: '请输入您的密码',
  submit: '提交',
  error_phone: '请输入正确的手机号码',
  error_email: '邮箱格式不正确,请重新输入',
  error_checked: '请先确认勾选协议',
  text: '密码格式错误，密码必须是8-32位，同时包含大小写字母和数字。',
  validate: '请完成验证',
  register_success: '注册成功！',
  welcome: '币王欢迎您',
  start_trade: '充值加密货币开始交易',
  safe: '多种充值方式，安全、便捷交易加密货币',
  pay_type: '通过银行卡或其他支付方式买卖加密货币',
  right_now_download: '立即前往下载',
  right_download: '前往下载',
  'Please_enter_correct_phone_number':'请输入正确的手机号码',
  'Referral_code':'请输入您的邀请码',
  'I_have_read_and_agree':'我已阅读并同意',
  'BiKing_User_Agreement':'《BiKing用户协议》',
  'Please_enter_password':'请输入您的密码',
  'Email_verification_code':'邮箱验证码',
  'SMS_code':'短信验证码',
  'Incorrect_email_format_please_reenter':'邮箱格式不正确,请重新输入',
  'Please_read_and_agree_User_Agreement':'请阅读并同意用户协议',
  'Sent_code_to':'已发送验证码至',
  zjff: '直接发放！',
  ycxdz: '一次性到账！',
  bbsy: '0成本博百倍收益！',
  sdly: '选择币王交易的三大理由',
  aqfktx: '世界顶尖安全风控体系',
  aqhg: '安全合规 可信赖的价值网络 专业分布式架构和防 DDOS 攻击系统',
  qqbthyytd: '全球本土化运营团队',
  qqbj: '全球布局 多个国家本土服务 打造多业务形态区块链生态圈',
  fwtx: '重塑以用户为本服务体系',
  yhzs: '用户至上 独创先行赔付机制 设立用户保护基金',
  jslc: '解锁流程',
  zcwcjkjs: '注册完成后，1188USDT以赠金账户余额形式发放，进入赠金账户即可解锁。',
  czts: '操作示例：您在成功注册后将领取到的1000USDT购买20倍杠杆BTC多单，当BTC上涨1%时，您即获得20%收益，即200USDT，该收益可直接提现。',
  zhu: '注：',
  qzlqyky: '1188USDT单笔分批发放及领取，全种类合约可用',
  gqql: '1188USDT使用期1个月，过期清零',
  
}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/zh.js